module.exports = __webpack_public_path__ + "img/2.4632cb89.png";